import * as Yup from 'yup';

import { signupSenioritiesOptions as defaultSignupSenioritiesOptions } from '../../../defaultFilters';

export const useSignupLevelOfExperienceFilter = ({ setFilters }) => {
  const levelOfExperienceOptions = defaultSignupSenioritiesOptions;

  const formSchema = Yup.object().shape({
    signupSeniorities: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSubmit = ({ signupSeniorities }) => {
    setFilters({ signupSeniorities });
  };

  return {
    formSchema,
    onSubmit,
    levelOfExperienceOptions,
  };
};
